import React, { useState, useEffect } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

function ConfirmOrderDialog({ orderId, onClose, onSaved }) {

    const [storageAvailability, setStorageAvailability] = useState([])
    const [storageSelection, setStorageSelection] = useState({})

    useEffect(() => {
        if (orderId) {
            fetchStorageAvailability(orderId)
        }
    }, [orderId])

    const fetchStorageAvailability = async (id) => {
        const res = await Api.get(`/sales_orders/${id}/availability`)
        setStorageAvailability(res.data || [])
        const initialSelection = {};
        (res.data || []).forEach(product => {
            initialSelection[product.product] = {};
            (product.warehouses || []).forEach(wh => {
                initialSelection[product.product][wh.warehouse] = Number(wh.allocated) || 0
            })
        })
        setStorageSelection(initialSelection)
    }

    const handleStorageInputChange = (product, warehouse, value) => {
        setStorageSelection(prev => ({
            ...prev,
            [product]: {
                ...prev[product],
                [warehouse]: Number(value)
            }
        }))
    }

    const isAllAllocated = storageAvailability.length > 0 && storageAvailability.every(product => {
        const totalAllocated = Object.values(storageSelection[product.product] || {}).reduce((sum, v) => sum + Number(v), 0)
        return totalAllocated === Number(product.needed)
    })

    const isProductFullyAllocated = (product) => {
        const totalAllocated = Object.values(storageSelection[product.product] || {}).reduce((sum, v) => sum + Number(v), 0)
        return totalAllocated >= Number(product.needed)
    }

    const isWarehouseInputDisabled = (product, wh) => {
        if (!storageSelection[product.product]) return false
        const totalAllocated = Object.values(storageSelection[product.product]).reduce((sum, v) => sum + Number(v), 0)
        return totalAllocated >= Number(product.needed) && Number(storageSelection[product.product][wh.warehouse]) === 0
    }

    const handleSave = async () => {
        const storages = []
        Object.entries(storageSelection).forEach(([product, warehouses]) => {
            Object.entries(warehouses).forEach(([warehouse, allocated]) => {
                if (Number(allocated) > 0) {
                    storages.push({ product, warehouse, allocated: Number(allocated) })
                }
            })
        })

        try {
            await Api.post(`/sales_orders/${orderId}/confirm`, { storages })
            onSaved()
        } catch (e) {
            console.log(e)
        }

        onClose()
    }

    return (
        <div className={`visible overlay`}>
            <div className={`show large popup-primary`}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('onlineSales.confirmOrderTitle') || 'Confirm Order and Select Storages'}
                        </h2>
                        <p>{trans('subheadings.confirmOrderTitle')}</p>
                    </div>
                    <span className='close' onClick={onClose}>

                    </span>
                </div>
                <strong style={{ fontWeight: 600, marginBottom: 15, fontFamily: "Inter SemiBold", display: "block" }}>{trans('onlineSales.selectStorages') || 'Select how many items to use from each storage:'}</strong>
                {storageAvailability.length === 0 ? (
                    <div>{trans('random.noDataFound') || 'No products found.'}</div>
                ) : (
                    <div>
                        {storageAvailability.map(product => (
                            <div key={product.product} className='pannel' style={{ marginBottom: 10 }}>
                                <h3 style={{ fontWeight: 600, marginBottom: 4, fontFamily: "Inter SemiBold", }}>{product.product}</h3>
                                <div style={{ marginBottom: 8, color: '#888', fontSize: "12px" }}>{trans('onlineSales.labels.needed') || 'Needed'}: {product.needed}</div>
                                <table style={{ width: '100%', marginBottom: 8 }}>
                                    <thead>
                                        <tr>
                                            <th>{trans('labels.storage') || 'Warehouse'}</th>
                                            <th>{trans('onlineSales.labels.available') || 'Available'}</th>
                                            <th>{trans('onlineSales.labels.useFromHere') || 'Allocate'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(product.warehouses || []).map(wh => {
                                            const disabled = isWarehouseInputDisabled(product, wh)
                                            return (
                                                <tr key={wh.warehouse}>
                                                    <td>{wh.warehouse}</td>
                                                    <td>{wh.available}</td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            max={Number(wh.available)}
                                                            value={storageSelection[product.product]?.[wh.warehouse] ?? ''}
                                                            onChange={e => handleStorageInputChange(product.product, wh.warehouse, e.target.value)}
                                                            style={{ width: 80 }}
                                                            disabled={disabled}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                                {!isProductFullyAllocated(product) && (
                                    <div style={{ color: '#e57373', fontSize: 13 }}>
                                        {trans('onlineSales.pleaseAllocateAll') || 'Please allocate the full needed quantity.'}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                <div className="footer align-right">
                    <button onClick={onClose}>
                        {trans('buttons.close')}
                    </button>

                    <button
                        onClick={handleSave}
                        className='button-primary'
                        disabled={!isAllAllocated}
                    >
                        {trans('buttons.save')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmOrderDialog
